<template>
  <section class="privacy">
    <form
      data-vv-scope="setPrivacyForm"
      @submit.prevent="setPrivacy"
      class="privacy-form"
    >
      <div v-if="pageLoader"><button class="button-loader"></button></div>
      <div
        v-else
        v-for="privacyEntity in privacyEntities"
        class="form-group"
        :key="privacyEntity.key"
      >
        <label :for="'privacy-' + privacyEntity.key" class="label"
          >{{ privacyEntity.label }}:</label
        >
        <multiselect
          v-if="user.vip"
          v-model="localPrivacy[privacyEntity.key]"
          :options="options"
          :searchable="false"
          :custom-label="(opt) => types[opt]"
          selectLabel=""
          deselectLabel=""
          :option-height="26"
          :allowEmpty="false"
          openDirection="bottom"
          :id="'privacy-' + privacyEntity.key"
          :placeholder="$t('settings.allUsers')"
          class="multiselect-no-overflow"
        ></multiselect>
        <multiselect
          v-else
          v-model="notVipValue"
          :options="notVipOptions"
          :searchable="false"
          :custom-label="customLabel"
          :show-labels="false"
          :option-height="26"
          :allowEmpty="false"
          selectLabel=""
          deselectLabel=""
          openDirection="bottom"
          :id="'privacy-' + privacyEntity.key"
          :placeholder="$t('settings.allUsers')"
          class="multiselect-no-overflow"
        >
          <template slot="singleLabel" slot-scope="props">
            <span>{{ props.option.text }}</span>
          </template>
          <template slot="option" slot-scope="props">
            <span>{{ props.option.text }}</span>
          </template>
        </multiselect>
      </div>

      <div class="buttons-row">
        <button
          @click="resetPrivacyForm"
          type="button"
          class="button-secondary"
        >
          {{ $t("settings.cancel") }}
        </button>
        <button v-if="!loader" type="submit" class="button">
          {{ $t("settings.save") }}
        </button>
        <button
          v-if="loader"
          type="button"
          class="button button-loader"
        ></button>
      </div>
    </form>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import Multiselect from "@/components/Blocks/Multiselect";

export default {
  name: "Privacy",
  props: {
    i18n: Object,
  },
  components: { Multiselect },
  data() {
    return {
      tempPrivacy: {},
      privacyEntities: [
        {
          key: "profile",
          label: this.$t("settings.viewQuestionnaire"),
        },
        {
          key: "messages",
          label: this.$t("settings.toWriteMessages"),
        },
        {
          key: "invites",
          label: this.$t("settings.inviteGame"),
        },
        {
          key: "photos",
          label: this.$t("settings.viewPhotos"),
        },
        {
          key: "videos",
          label: this.$t("settings.viewVideos"),
        },
        // {
        //     key: 'friends',
        //     label: 'Просматривать моих друзей'
        // },
        {
          key: "comments",
          label: this.$t("settings.commentPhotosVideos"),
        },
      ],
      pageLoader: true,
      loader: false,
      options: [0, 1],
      types: [this.$t("settings.allUsers"), this.$t("settings.onlyFriendsVip")],
      notVipValue: { text: this.$t("settings.allUsers"), link: "" },
      notVipOptions: [
        { text: this.$t("settings.allUsers"), link: "" },
        {
          text: this.$t("settings.onlyFriendsVip"),
          link: this.$t("settings.buyVip"),
          $isDisabled: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      userIsEmpty: "user/isEmpty",
      user: "user/fetchUser",
      userErrors: "user/errors",
      privacyIsEmpty: "privacy/isEmpty",
      privacy: "privacy/fetchPrivacy",
      privacyErrors: "privacy/errors",
    }),
    localPrivacy: function () {
      if (Object.keys(this.tempPrivacy).length) {
        return this.tempPrivacy;
      }
      this.tempPrivacy = Object.assign({}, this.privacy);
      return this.tempPrivacy;
    },
  },
  created() {
    this.getPrivacy();
  },
  methods: {
    customLabel({ text, link }) {
      return `${text} – ${link}`;
    },
    getPrivacy() {
      this.$store
        .dispatch("privacy/getPrivacy")
        .then(() => {
          this.pageLoader = false;
        })
        .catch(() => {
          this.pageLoader = false;
        });
    },
    setPrivacy() {
      this.loader = true;
      this.$store
        .dispatch("privacy/setPrivacy", this.localPrivacy)
        .then(() => {
          this.loader = false;
          this.$modal.show("dialog", {
            text: this.$t("settings.theSuccessfullySaved"),
            buttons: [
              {
                title: this.$t("roulette.ok"),
              },
            ],
          });
        })
        .catch(() => {
          this.loader = false;
        });
    },
    resetPrivacyForm() {
      this.tempPrivacy = Object.assign({}, this.privacy);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/layout/_privacy";
</style>
